angular.module('surfsightApp.controllers').controller('SignUpCtrl', [
  '$scope',
  '$rootScope',
  '$state',
  '$timeout',
  '$interval',
  '$http',
  '$mdDialog',
  '$mdToast',
  '$mdColors',
  '$localStorage',
  '$filter',
  function (
    $scope,
    $rootScope,
    $state,
    $timeout,
    $interval,
    $http,
    $mdDialog,
    $mdToast,
    $mdColors,
    $localStorage,
    $filter
  ) {
    var $translate = $filter('translate')
    $scope.themePrimary = $mdColors.getThemeColor('primary')
    $scope.signup_data = {}
    $scope.showErrorMsg = false
    $scope.errorMessages = ''
    $scope.regEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
    $scope.acceptedTermsConditions = true
    $scope.register = function () {
      if (!$scope.terms_conditions || $scope.terms_conditions === 'false') {
        $scope.showErrorMsg = false
        $scope.acceptedTermsConditions = false
        return false
      } else {
        $scope.acceptedTermsConditions = true
      }
      if ($scope.signup_data.password !== $scope.signup_data.confirm_password) {
        $scope.showErrorMsg = true
        $scope.errorMessages = $translate(
          'passwordAndConfirmPasswordDoNotMatch'
        )
        return false
      } else {
        $scope.signup_data.name = ''
        var request_json = {
          method: 'POST',
          url: USER_BASEURL + '/user_signup',
          data: $scope.signup_data
        }
        $http(request_json).then(
          function (response) {
            if (response.data.status.code === 0) {
              alert($translate('registrationCompletedSuccessfully'))
              $state.go('home.login')
              $scope.showErrorMsg = false
            } else {
              $scope.showErrorMsg = true
              $scope.errorMessages = $translate(response.data.status.error)
            }
          },
          function (response) {
            alert(response.data.status.error)
          }
        )
      }
    }
    $scope.gotoLoginScreen = function () {
      $state.go('home.login')
    }
  }
])
